import translations from "../../../translations"
import * as I18n from "../../../services/i18n"

$(document).on 'turbolinks:load', ->
  $('#import_step_templates_modal').off 'show.bs.modal'
  $('#import_step_templates_modal').off 'hidden.bs.modal'

  $('#import_step_templates_modal').on 'show.bs.modal', ->
    loadStepTemplates()

  $('#import_step_templates_modal').on 'hidden.bs.modal', ->
    $('#step-templates-list input[type="checkbox"]').prop('checked', false)
    $('#select-all-templates').prop('checked', false).prop('indeterminate', false)
    updateSelectAllText(false)
    updateImportButton()

  $(document).on 'change', '#select-all-templates', ->
    isChecked = $(this).is(':checked')
    $('#step-templates-list input[type="checkbox"]').prop('checked', isChecked)
    updateSelectAllText(isChecked)
    updateImportButton()

  $(document).on 'change', '#step-templates-list input[type="checkbox"]', ->
    updateImportButton()
    updateSelectAllCheckbox()

  $('#import-templates-btn').off('click').on 'click', ->
    importSelectedTemplates()

  loadStepTemplates = ->
    $.ajax
      url: '/empresa/modelos-etapas/search.json'
      method: 'GET'
      dataType: 'json'
      success: (data) ->
        renderTemplatesList(data)
      error: ->
        $('#step-templates-list').html """
          <div class="alert alert-danger">
            <i class="fa fa-exclamation-triangle"></i>
            #{I18n.t(translations(), 'atividades.index.import_templates.error_loading')}
          </div>
        """

  renderTemplatesList = (templates) ->
    if templates.length == 0
      $('#step-templates-list').html """
        <div class="alert alert-info">
          <i class="fa fa-info-circle"></i>
          #{I18n.t(translations(), 'atividades.index.import_templates.no_templates_found')}
        </div>
      """
      return

    templatesList = templates.map (template) ->
      weightText = I18n.t(translations(), 'atividades.index.import_templates.weight_label', { weight: template.weight })
      """
      <div class="mb-2">
        <label class="checkbox-inline">
          <input type="checkbox" value="#{template.id}" data-template-id="#{template.id}">
          <strong>#{template.name}</strong>
          <span class="text-muted">(#{weightText})</span>
        </label>
      </div>
      """

    $('#step-templates-list').html(templatesList.join(''))

    setTimeout ->
      updateImportButton()
      updateSelectAllCheckbox()
    , 100

  updateSelectAllText = (isChecked) ->
    label = $('#select-all-templates').closest('label')
    text = if isChecked
      I18n.t(translations(), 'atividades.index.import_templates.deselect_all')
    else
      I18n.t(translations(), 'atividades.index.import_templates.select_all')
    label.contents().last()[0].textContent = ' ' + text

  updateImportButton = ->
    selectedCount = $('#step-templates-list input[type="checkbox"]:checked').length
    $('#import-templates-btn').prop('disabled', selectedCount == 0)

    if selectedCount > 0
      importText = I18n.t(translations(), 'atividades.index.import_templates.import_count', { count: selectedCount })
      $('#import-templates-btn').html("""
        <i class="icon icon-import"></i>
        #{importText}
      """)
    else
      $('#import-templates-btn').html("""
        <i class="icon icon-import"></i>
        #{I18n.t(translations(), 'atividades.index.import_templates.import_selected')}
      """)

  updateSelectAllCheckbox = ->
    totalCheckboxes = $('#step-templates-list input[type="checkbox"]').length
    checkedCheckboxes = $('#step-templates-list input[type="checkbox"]:checked').length

    if checkedCheckboxes == 0
      $('#select-all-templates').prop('indeterminate', false).prop('checked', false)
      updateSelectAllText(false)
    else if checkedCheckboxes == totalCheckboxes
      $('#select-all-templates').prop('indeterminate', false).prop('checked', true)
      updateSelectAllText(true)
    else
      $('#select-all-templates').prop('indeterminate', true).prop('checked', false)
      updateSelectAllText(false)

  importSelectedTemplates = ->
    selectedTemplateIds = []
    $('#step-templates-list input[type="checkbox"]:checked').each ->
      selectedTemplateIds.push($(this).val())

    if selectedTemplateIds.length == 0
      return

    $('#import-templates-btn').prop('disabled', true).html("""
      <i class="fa fa-spinner fa-spin"></i>
      #{I18n.t(translations(), 'atividades.index.import_templates.importing')}
    """)

    $.ajax
      url: '/atividades/import_step_templates'
      method: 'POST'
      dataType: 'json'
      data:
        step_template_ids: selectedTemplateIds
      success: (data) ->
        $('#import_step_templates_modal').modal('hide')

        message = if data && data.message then data.message else I18n.t(translations(), 'atividades.index.import_templates.success_message')
        showSuccessMessage(message)

        setTimeout ->
          Turbolinks.visit(window.location.href)
        , 1500

      error: (xhr) ->
        console.error('Erro na requisição:', xhr)

        errorMessage = if xhr.responseJSON && xhr.responseJSON.error
          xhr.responseJSON.error
        else
          I18n.t(translations(), 'atividades.index.import_templates.error_loading')

        showErrorMessage(errorMessage)

        $('#import-templates-btn').prop('disabled', false).html("""
          <i class="icon icon-import"></i>
          #{I18n.t(translations(), 'atividades.index.import_templates.import_selected')}
        """)

  showSuccessMessage = (message) ->
    if window.Error && typeof window.Error.show_success_flash_msg == 'function'
      window.Error.show_success_flash_msg(message, 4000)
    else
      alert("Sucesso: #{message}")

  showErrorMessage = (message) ->
    if window.Error && typeof window.Error.show_alert_flash_msg == 'function'
      window.Error.show_alert_flash_msg(message, 6000)
    else
      alert("Erro: #{message}")
